<template>
  <div id="my-header-oficina" class="w-100 h-auto d-flex flex-align-center flex-justify-between py-1"
       :class="$store.getters.navFgColor" :style="computedStyle">
    <div class="d-flex flex-align-center">
      <div class="vista-activa c-pointer" v-if="$route.matched.some(record => record.meta.koinoniaRoute) && vistaActiva"
           @click="$store.commit('SET_SHOW_SIDE_NAV',true)" key="side-nav-button">
        <img v-if="vistaActiva.picture_url" :src="vistaActiva.picture_url" alt="" class="k10-vista-pic-img">
        <div class="k10-vista-pic-siglas" :class="`k10-gradient-${vistaActiva.default_gradient}`" v-else>
          <div>{{ nameSiglas(vistaActiva.nombre) }}</div>
        </div>
      </div>
      <button class="button bg-transparent rounded" :class="$store.getters.navFgColor"
              @click="pathBack ? $router.push({path: pathBack}) : $router.back()" v-if="!showMenu" key="back-button">
        <span class="mif-arrow-left"></span>
      </button>
      <div class="text-bold ml-2 text-upper" style="font-size: 12px" v-if="titleMenu">
        {{ titleMenu }}
      </div>
    </div>
    <div class="d-flex flex-align-center">
      <button @click="$router.push({name: 'menu_principal'})" class="button bg-transparent rounded" key="home-button"
              v-if="!showMenu" :class="$store.getters.navFgColor">
        <i class="fa-solid fa-home"></i>
      </button>
      <template v-else>
        <div @click="$router.push({path: '/impulso-libertad'})" class="c-pointer" key="insignia-libertad"
             v-if="insignia_libertad">
          <img src="https://bckt-static.s3.us-west-1.amazonaws.com/impulso-libertad/logo.png" style="max-height: 50px"
               alt="">
        </div>
        <div @click="$router.push({path: '/tarjeta-alianza'})" class="c-pointer" key="insignia-alianza"
             v-if="insignia_alianza">
          <img src="@/assets/images/icons/tarjeta-alianza.webp" style="max-height: 50px" alt="">
        </div>
        <button @click="$router.push({path: '/notifications'})" class="button bg-transparent rounded"
                key="notifications-button" :class="$store.getters.navFgColor">
          <i class="fa-solid fa-bell"></i>
          <span class="badge bg-green fg-white mt-1 mr-1" v-if="notifications > 0">{{ notifications }}</span>
        </button>
      </template>
    </div>

    <transition name="fade">
      <div id="side-nav-bg" class="pos-fixed pos-top-center z-1" v-if="showSideNav"></div>
    </transition>

    <transition name="slide-ltr">
      <keep-alive>
        <koinonia-side-nav v-if="showSideNav" class="z-2"></koinonia-side-nav>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import koinoniaSideNav from "@/components/koinonia10/side-nav.vue"
import {siglas} from "@/mixins/koinonia10/siglas"

export default {
  name: 'nav-bar',
  data() {
    return {
      notifications: 0, //No hace nada, hay que ver la manera de marcar notificaciones como leídas
    }
  },
  mixins: [siglas],
  components: {
    koinoniaSideNav
  },
  computed: {
    computedStyle() {
      return {
        'background': `linear-gradient(to right, ${this.$store.state.navColor1}, ${this.$store.state.navColor2})`,
      }
    },
    titleMenu: function () {
      return this.$store.state.title_menu;
    },
    showMenu: function () {
      return this.$store.state.show_menu;
    },
    pathBack: function () {
      return this.$store.state.path_back;
    },
    insignia_libertad: function () {
      return this.$store.state.user !== null ? this.$store.state.user.insignia_libertad : false
    },
    insignia_alianza: function () {
      return this.$store.state.user !== null ? this.$store.state.user.insignia_alianza : false
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
    vistaActiva() {
      return this.$store.getters.vistaDifusionActiva
    },
    showSideNav() {
      return this.$store.getters.showSideNav
    }
  }
}
</script>

<style scoped>
#my-header-oficina {
  min-height: 52px;
  max-width: 100vw;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
#side-nav-bg {
  background-color: rgba(33,31,31,0.5);
  height: calc(var(--vh) * 100);
  width: 100%;
}
.vista-activa {
  width: 40px;
  height: 36px;
  padding: 6px 8px;
  line-height: 1;
}
</style>
